import { fromFetch } from 'rxjs/fetch';
import { switchMap, of, catchError } from 'rxjs';
import { getSelfGuidedTourPlanTourableSpecs } from 'constants/routes';

/**
 * Fetches the tourable siblings for a given plan Id.
 * @param {string} planId - The plan Id to fetch spec details for.
 * @returns {Observable} An observable that emits the tourable siblings array or an error object.
 */
export default function getPlanTourableSpecs(planId) {
  const url = `${getSelfGuidedTourPlanTourableSpecs}?planId=${planId}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).pipe(
    switchMap((response) => {
      if (response.ok) {
        return response.json();
      }
      return of({ error: true, message: 'Error fetching data' });
    }),
    catchError((error) => of({ error: true, message: error.message }))
  );
}
